import React from "react";

const UnauthorizedPage = () => {
    return (
        <div>
            <p>UnauthorizedPage</p>
        </div>
    );
};

export default UnauthorizedPage;
